import { observableEvent } from '../_utils/observable-event';

async function deleteOnServer({ url, redirect, ...params }) {
  const formData = buildFormData(params);

  const response = await fetch(url, {
    method: 'DELETE',
    body: formData,
    credentials: 'same-origin',
  });

  handleResponse(response, redirect);

  try {
    const data = await response.json();
    updateBasketQuantity(data.quantity);
  } catch (e) {}
}

async function updateOnServer({ url, redirect, ...params }) {
  const formData = buildFormData(params);

  const response = await fetch(url, {
    method: 'PUT',
    body: formData,
    credentials: 'same-origin',
  });

  handleResponse(response, redirect);

  let data;
  try {
    data = await response.json();
    updateBasketQuantity(data.quantity);
  } catch (e) {}
  return data;
}

function buildFormData(params) {
  const formData = new FormData();
  const permittedParams = [
    'size',
    'finish',
    'prism_id',
    'soft',
    'item',
    'quantity',
    'option',
  ];

  Object.entries(params).forEach(([key, value]) => {
    if (permittedParams.includes(key)) {
      if (key === 'quantity') {
        formData.append('values[copies]', value);
      } else {
        formData.append(key, value);
      }
    }
  });

  return formData;
}

function updateBasketQuantity(quantity) {
  if (quantity != null) {
    App.order.set('no_items', quantity);
  }
}

function handleResponse(response, redirect) {
  if (!response.ok) {
    observableEvent.record('cart-server-action-fail', {
      status: response.status,
      url: response.url.replace(window.location.origin, ''),
    });

    if (response.status === 404) {
      window.location = redirect;
    }
  }
}

export { updateOnServer, deleteOnServer };
